import { assessmentSummaryConstants } from '../../_constants';

const initialState = { getAssessmentLoading: true, data: '', error: false };

export function getAssessmentSummary(state = initialState, action) {
    
    switch (action.type) {
        case assessmentSummaryConstants.REQUEST_ASSESSMENT:
            return {
                getAssessmentLoading: true,
                data: '',
                error: false
            };
        case assessmentSummaryConstants.RECEIVE_ASSESSMENT:
            return {
                getAssessmentLoading: false,
                data: action.getAssessement,
                error: false
            };
        case assessmentSummaryConstants.ASSESSMENT_ERROR:
            return {
                getAssessmentLoading: false,
                data: '',
                error: true
            };
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/_reducers/assessmentSummary/getAssessment.reducer.js